/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export var PersistStoreMap = new Map();
